var map = {
	"./0.png": "49fb",
	"./1.png": "3f59",
	"./10.png": "dfb5",
	"./11.png": "24a2",
	"./2.png": "648e",
	"./3.png": "e246",
	"./4.png": "f5b7",
	"./5.png": "316c",
	"./6.png": "bb2e",
	"./7.png": "2a22",
	"./8.png": "474c",
	"./9.png": "106d",
	"./big-paper.png": "98b7",
	"./cog-turn.png": "f0f3",
	"./cog.png": "3d18",
	"./grey-tape.png": "11e9",
	"./hex1.png": "95f0",
	"./hex2.png": "ce6d",
	"./hex3.png": "b062",
	"./small-paper.png": "f0a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16fa";